import { Expose } from "class-transformer";

export class RemoveScheduledDatesDto {
  @Expose()
  projectId: string;

  @Expose()
  userId: string;
}
